angular
    .module('app')
    .component('winbackOffersAdd', {
        templateUrl: '/templates/pages/winback-offers/winback-offers-add/winback-offers-add.html',
        controller: 'WinbackOffersAddController',
        controllerAs: 'vm',
    });